import createReactComponent from '../createReactComponent';
var Crop = createReactComponent('Crop', [['path', {
  d: 'M6.13 1L6 16a2 2 0 002 2h15',
  key: '1t2380'
}], ['path', {
  d: 'M1 6.13L16 6a2 2 0 012 2v15',
  key: '1to7s2'
}]]);
export default Crop;